import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  ToolbarPropsOverrides,
  useGridApiContext,
} from '@mui/x-data-grid-premium';
import IncExportButton from 'components/inc-export-button/inc-export-button.component';
import {
  useSearchParamsContext,
  useSearchQueryContext,
} from 'components/search/search.hooks';
import omit from 'lodash.omit';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { downloadCSV } from 'util/download-csv.utils';
import { EmailPulseExportMutationHook } from '../email-pulse.types';
import { makeParamsBody } from '../email-pulse.utils';

type EmailPulseExportConfig = {
  query: EmailPulseExportMutationHook;
  fileName: string;
  queryName: string;
  filteredSearchParams: string[];
  includeColumnsField: boolean;
};

const EmailPulseDataGridToolbar = ({ toolbar }: ToolbarPropsOverrides) => {
  const { enqueueSnackbar } = useSnackbar();
  const { searchParams } = useSearchParamsContext();
  const {
    queryName,
    filteredSearchParams: fsp,
    query,
    fileName,
    includeColumnsField,
  } = toolbar.export as unknown as EmailPulseExportConfig;
  const { queryState } = useSearchQueryContext(queryName);
  const filteredSearchParams = omit(searchParams, fsp);
  const api = useGridApiContext();

  const [exportCSV, { isLoading, isSuccess, data }] = query();

  const handleExportCSV = async () => {
    await exportCSV({
      columns: includeColumnsField
        ? (api.current.getVisibleColumns().map(col => col.field) as string[])
        : undefined,
      ...makeParamsBody(filteredSearchParams),
    });
  };

  useEffect(() => {
    if (isSuccess) {
      if (data.data?.REPORT) {
        downloadCSV(data.data.REPORT, fileName);
      } else {
        enqueueSnackbar(data.responseMessage, {
          severity: 'success',
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <GridToolbarContainer
      sx={{ display: 'flex', justifyContent: 'space-between' }}
    >
      <GridToolbarColumnsButton />
      <IncExportButton
        label="Export"
        onClick={handleExportCSV}
        data-testid="EmailPulseDataGridToolbar.IncExportButton"
        disabled={queryState.isFetching}
        loading={isLoading}
        loadingPosition="start"
      />
    </GridToolbarContainer>
  );
};

export default EmailPulseDataGridToolbar;
